// src/api/admin.js
export async function listUsers() {
  const res = await fetch('/api/admin/users', { credentials: 'include' });
  return res.json();
}

export async function toggleTranscribe(userId, enable) {
  const res = await fetch(`/api/admin/users/${userId}/transcribe`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ enable })
  });
  return res.json();
}

export async function updatePlan(userId, plan) {
  const res = await fetch(`/api/admin/users/${userId}/plan`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ plan })
  });
  return res.json();
}

export async function updateUsage(userId, payload) {
  const res = await fetch(`/api/admin/users/${userId}/usage`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return res.json();
}

export async function resetUsage(userId) {
  const res = await fetch(`/api/admin/users/${userId}/usage/reset`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' }
  });
  return res.json();
}

export async function fetchStats() {
  const res = await fetch('/api/admin/stats', { credentials: 'include' });
  return res.json();
}
